import React, { useState } from "react";

import styles from "../../styles/GlobalChallengeAdmin.module.scss";

import BulkRegistrationForm from "./BulkRegistrationForm";
import CreateChallengeForm from "./CreateChallengeForm";
import LeaderboardViewer from "./LeaderboardViewer";

const AdminPortal = () => {
  const [activeTab, setActiveTab] = useState<
    "create" | "register" | "leaderboard"
  >("create");

  return (
    <div className={styles.wrap}>
      <div className={styles.header}>
        <h1 className={styles.title}>Global Challenge Platform Admin</h1>
        <div className={styles.tabs}>
          <button
            className={`${styles.tab} ${activeTab === "create" ? styles.active : ""}`}
            onClick={() => setActiveTab("create")}
            type="button"
          >
            Create Challenge
          </button>
          <button
            className={`${styles.tab} ${activeTab === "register" ? styles.active : ""}`}
            onClick={() => setActiveTab("register")}
            type="button"
          >
            Register Participants
          </button>
          <button
            className={`${styles.tab} ${activeTab === "leaderboard" ? styles.active : ""}`}
            onClick={() => setActiveTab("leaderboard")}
            type="button"
          >
            View Leaderboard
          </button>
        </div>
      </div>

      <div className={styles.content}>
        {activeTab === "create" && <CreateChallengeForm />}
        {activeTab === "register" && <BulkRegistrationForm />}
        {activeTab === "leaderboard" && <LeaderboardViewer />}
      </div>
    </div>
  );
};

export default AdminPortal;
